import Modal from '@shared/components/Basic/ModalButBetter/Modal'
import Step from '@shared/components/Basic/ModalButBetter/Step'

export default {
  container: Modal,
  step: Step,
}